import React, { useEffect, useState } from "react";
import Logo from "@/components/Logo";
import { Menu, X, ArrowUpRight } from "lucide-react";

const links = [
  { href: "#nosotros", label: "Nosotros" },
  { href: "#servicios", label: "Servicios" },
  { href: "#porque", label: "¿Por qué nosotros?" },
  { href: "#sectores", label: "Sectores" },
  { href: "#contacto", label: "Contacto" },
];

export const Nav = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
  }, [open]);

  const handleLink = (e, href) => {
    e.preventDefault();
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="main-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#181C24]/85 backdrop-blur-xl border-b border-white/10"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Logo />

          <nav className="hidden lg:flex items-center gap-9">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-link-${l.href.slice(1)}`}
                onClick={(e) => handleLink(e, l.href)}
                className="link-underline text-sm text-white/80 hover:text-white transition-colors"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <a
              href="#contacto"
              onClick={(e) => handleLink(e, "#contacto")}
              data-testid="nav-cta-quote"
              className="hidden sm:inline-flex items-center gap-2 btn-supernova px-5 py-3 text-sm font-semibold tracking-wide uppercase"
            >
              Solicitar Cotización
              <ArrowUpRight className="w-4 h-4" />
            </a>

            <button
              type="button"
              onClick={() => setOpen((v) => !v)}
              data-testid="hamburger-toggle"
              aria-label="Abrir menú"
              className="lg:hidden w-11 h-11 inline-flex items-center justify-center border border-white/15 hover:border-[#F8BC33] transition-colors"
            >
              {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      <div
        data-testid="mobile-menu"
        className={`lg:hidden fixed inset-0 top-20 bg-[#181C24] mobile-menu-enter ${
          open ? "open" : ""
        }`}
      >
        <div className="px-6 py-10 flex flex-col gap-6">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`mobile-nav-link-${l.href.slice(1)}`}
              onClick={(e) => handleLink(e, l.href)}
              className="font-display font-bold text-3xl text-white hover:text-[#F8BC33] transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contacto"
            onClick={(e) => handleLink(e, "#contacto")}
            data-testid="mobile-cta-quote"
            className="mt-6 btn-supernova w-full inline-flex items-center justify-center gap-2 py-4 text-sm font-semibold tracking-wide uppercase"
          >
            Solicitar Cotización <ArrowUpRight className="w-4 h-4" />
          </a>
          <div className="mt-8 pt-8 border-t border-white/10 text-sm text-white/50 space-y-2 font-mono-tech">
            <p>tel: +52 844 000 0000</p>
            <p>contacto@infratelco.mx</p>
            <p>Saltillo · Coahuila · MX</p>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Nav;
